// extracted by mini-css-extract-plugin
module.exports = {"container":"_19L48MD","grid":"Azf2OJG","column1":"_17rqztO","column2":"_262Lptu"};